import { Link } from "react-router-dom";

export function SiteFooter() {
  return (
    <footer className="relative mt-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pb-12">
        <div className="glass-panel rounded-3xl px-6 py-10 sm:px-10">
          <div className="grid gap-8 lg:grid-cols-[1.3fr_0.7fr] lg:items-center">
            <div>
              <div className="font-[var(--font-display)] text-2xl sm:text-3xl tracking-tight text-white">
                Build Your Intelligent Operations Nervous System
              </div>
              <div className="mt-3 max-w-2xl text-sm sm:text-base text-[var(--text-secondary)]">
                Every enterprise needs a central nervous system for IT operations. Let us help you build yours.
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 lg:justify-end">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center rounded-xl px-4 py-2 text-sm font-medium text-[#061019] bg-[var(--accent-primary)] hover:brightness-110"
              >
                Schedule Executive Workshop
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center rounded-xl px-4 py-2 text-sm font-medium text-white border border-white/15 bg-white/5 hover:bg-white/8"
              >
                Start AIOps & ROI Assessment
              </Link>
            </div>
          </div>

          <div className="mt-10 grid gap-6 border-t border-white/8 pt-8 sm:grid-cols-2 lg:grid-cols-4">
            <div>
              <div className="text-xs uppercase tracking-widest text-[var(--text-secondary)]">Contact</div>
              <div className="mt-3 text-sm text-white">info@ivalue.co.in</div>
              <div className="mt-1 text-sm text-[var(--text-secondary)]">Phone: +91 95359 99473</div>
            </div>
            <div>
              <div className="text-xs uppercase tracking-widest text-[var(--text-secondary)]">Focus</div>
              <div className="mt-3 space-y-2 text-sm">
                <div className="text-[var(--text-secondary)]">AIOps, SRE, Network Intelligence</div>
                <div className="text-[var(--text-secondary)]">Outcome-driven, vendor-agnostic</div>
              </div>
            </div>
            <div>
              <div className="text-xs uppercase tracking-widest text-[var(--text-secondary)]">Quick Links</div>
              <div className="mt-3 grid gap-2 text-sm">
                <Link to="/capabilities" className="text-[var(--text-secondary)] hover:text-white">
                  Capabilities
                </Link>
                <Link to="/technology-stack" className="text-[var(--text-secondary)] hover:text-white">
                  Technology Stack
                </Link>
                <Link to="/architecture" className="text-[var(--text-secondary)] hover:text-white">
                  Reference Architecture
                </Link>
              </div>
            </div>
            <div>
              <div className="text-xs uppercase tracking-widest text-[var(--text-secondary)]">Legal</div>
              <div className="mt-3 text-sm text-[var(--text-secondary)]">
                © {new Date().getFullYear()} AIOps & Observability CoE. All rights reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
